var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71476 6.54244L3.343 7.9142C2.17143 9.08577 2.17143 10.9853 3.343 12.1568C4.51457 13.3284 6.41407 13.3284 7.58564 12.1568L9.41407 10.3284C10.5856 9.15684 10.5856 7.25735 9.41407 6.08577C9.16613 5.83784 8.88559 5.64237 8.58625 5.49938L7.99985 6.08578C7.93888 6.14675 7.88742 6.21365 7.84548 6.28461C8.16092 6.37499 8.4585 6.54442 8.70696 6.79288C9.48801 7.57393 9.48801 8.84026 8.70696 9.62131L6.87853 11.4497C6.09749 12.2308 4.83116 12.2308 4.05011 11.4497C3.26906 10.6687 3.26906 9.40236 4.05011 8.62131L4.84271 7.8287C4.73052 7.40858 4.68787 6.97375 4.71476 6.54244Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58564 4.67156C5.41407 5.84313 5.41407 7.74263 6.58564 8.9142C6.83358 9.16214 7.11411 9.3576 7.41345 9.5006L8.18905 8.72501C7.86071 8.63732 7.55034 8.46468 7.29275 8.2071C6.5117 7.42605 6.5117 6.15972 7.29275 5.37867L9.12118 3.55024C9.90222 2.76919 11.1686 2.76919 11.9496 3.55024C12.7307 4.33129 12.7307 5.59762 11.9496 6.37867L11.157 7.17128C11.2692 7.5914 11.3118 8.02623 11.2849 8.45754L12.6567 7.08577C13.8283 5.9142 13.8283 4.01471 12.6567 2.84313C11.4851 1.67156 9.58564 1.67156 8.41407 2.84313L6.58564 4.67156Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.7a556a7fd71992609547deffc56db647.svg";
export { ForwardRef as ReactComponent };